import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-zinc-950 px-5 py-20 md:py-28" data-id="element-99" data-mp="uqj258fdg88g">
      <div className="mx-auto max-w-3xl" data-id="element-100" data-mp="ut5ahaa36rrq">
        <SectionHeading title="Preguntas frecuentes" data-id="element-101" data-mp="70f2td97uun9" />
        <ul className="mt-12 space-y-3" data-id="element-102" data-mp="731iy1a6aih3">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className={`rounded-lg border bg-zinc-900 transition-colors duration-200 ${isOpen ? 'border-amber-400/60' : 'border-zinc-800'}`} data-id="element-103" data-mp="gz4kp6144f3i" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 rounded-lg px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/50" data-id="element-104" data-mp="bz00p60zx28j">
                  <span className="text-lg font-semibold text-zinc-50 md:text-xl" data-id="element-105" data-mp="hso1nat2f7lf">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-amber-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-106" data-mp="ms0ymodnhv1q" />
                </button>
                <AnimatePresence initial={false} data-id="element-107" data-mp="vu0ehdcxit33">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-108" data-mp="vr5xjvt4jqef">
                      <p className="px-6 pb-6 text-lg leading-relaxed text-zinc-400" data-id="element-109" data-mp="3ci49tm6lf2cm">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}